import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AdminCards.css";

export default function DashboardCards() {
  return (
    <div className="container-fluid dashboard-cards-wrapper">
      <div className="row g-3">
        
        {/* Today's Revenue */}
        <div className="col-lg-4 col-md-6">
          <div className="dashboard-card">
            <p className="dashboard-card-title">Today's Revenue</p>

            <div className="dashboard-card-value">
              3,500 <span>AED</span>
            </div>

            <div className="dashboard-card-footer">
              <span className="dashboard-card-growth positive">▲ 15%</span>
              <MiniChart type="green" />
            </div>
          </div>
        </div>

        {/* Currency-wise Revenue */}
        <div className="col-lg-4 col-md-6">
          <div className="dashboard-card">
            <p className="dashboard-card-title">Currency-wise Revenue</p>

            <div className="dashboard-card-value">
              7,510 <span>AED</span>
            </div>

            <div className="dashboard-card-footer">
              <span className="dashboard-card-growth positive">▲ 8%</span>
              <MiniChart type="yellow" />
            </div>
          </div>
        </div>

        {/* Active Premium Users */}
        <div className="col-lg-4 col-md-12">
          <div className="dashboard-card">
            <p className="dashboard-card-title">Active Premium Users</p>

            <div className="dashboard-card-value">
              1,255
            </div>

            <div className="dashboard-card-footer">
              <span className="dashboard-card-growth positive">▲ 10%</span>
              <MiniChart type="blue" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

/* ===== Mini SVG Chart ===== */
function MiniChart({ type }) {
  return (
    <svg
      className={`dashboard-mini-chart ${type}`}
      viewBox="0 0 120 40"
      preserveAspectRatio="none"
    >
      {/* Area */}
      <path
        d="M0 30 L20 28 L40 25 L60 18 L80 15 L100 10 L120 8 L120 40 L0 40 Z"
        className="dashboard-chart-area"
      />

      {/* Line */}
      <path
        d="M0 30 L20 28 L40 25 L60 18 L80 15 L100 10 L120 8"
        className="dashboard-chart-line"
      />
    </svg>
  );
}
